if (!window.DigitalizModules) window.DigitalizModules = {};

if (!window.DigitalizModules.ServicesType) {
  class ServicesType {
    constructor(root) {
      this.root = root;
      this.splide = null;
      this._init();
    }

    _init() {
      if (typeof window.Splide !== 'function') return;
      if (this.root.dataset.servicesInit === '1') return;
      this.root.dataset.servicesInit = '1';

      const data = this.root.dataset;
      const loopMode = data.loopMode || 'loop';
      const autoplay = data.autoplay === 'true';
      const interval = parseInt(data.autoplayInterval, 10) || 4000;
      const pauseOnHover = data.pauseOnHover === 'true';
      const speed = parseInt(data.speed, 10) || 600;
      const gap = data.gap || '0rem';
      const showArrows = data.showArrows === 'true';

      const options = {
        // Center-peek slider: N full slides + a half slide peeking on each side.
        // padding % = 50 / (N + 1), so the peek is always exactly half a slide.
        //   >=1200px: 3 full (12.5%)  ·  <1200px: 2 full (16.667%)
        //   <992px: 1 full (25%)      ·  <768px: 1 full, no peek (mobile)
        perPage: 3,
        focus: 'center',
        padding: '12.5%',
        gap: gap,
        arrows: showArrows,
        pagination: false,
        speed: speed,
        breakpoints: {
          // <1200px: 2 full slides + a half peeking each side.
          // focus:0 (not 'center') — centering an even perPage collapses the
          // peek into a full slide; left-align + padding + loop keeps it
          // symmetric (half | full | full | half).
          1199: {
            perPage: 2,
            padding: '16.6667%',
            focus: 0,
          },
          // <992px: 1 full slide + a half peeking each side.
          991: {
            perPage: 1,
            padding: '25%',
          },
          // Mobile (<768px): one full slide per view, no peek. Side gutters are
          // handled by the .services-type__viewport wrapper in CSS.
          767: {
            perPage: 1,
            focus: 0,
            padding: 0,
          },
        },
      };

      if (loopMode === 'loop') {
        options.type = 'loop';
      } else if (loopMode === 'rewind') {
        options.rewind = true;
      }

      if (autoplay) {
        options.autoplay = true;
        options.interval = interval;
        options.pauseOnHover = pauseOnHover;
      }

      this.splide = new window.Splide(this.root, options).mount();
    }

    destroy() {
      if (this.splide) {
        this.splide.destroy();
        this.splide = null;
      }
      delete this.root.dataset.servicesInit;
    }
  }

  window.DigitalizModules.ServicesType = ServicesType;

  function initServicesSliders(root) {
    root.querySelectorAll('[data-services-slider]').forEach((el) => new ServicesType(el));
  }

  initServicesSliders(document);

  // Re-init when the Theme Editor adds or re-renders this section.
  document.addEventListener('shopify:section:load', (event) => {
    initServicesSliders(event.target);
  });
}
